import { Workflows } from "../steps/medical-questions/workflows"
import { useRoutingInfo } from "../context/RoutingInfoContext"

export const useMedicalInfoWorkflow = () => {
  const { routingData } = useRoutingInfo()
  const workflow = getWorkflow(routingData)
  const IsAMAB = workflow === Workflows.AMAB_MEDICAL_QUESTIONS
  const IsAFAB = workflow === Workflows.AFAB_MEDICAL_QUESTIONS
  return { workflow, IsAMAB, IsAFAB }
}

function getWorkflow(routingData): Workflows {
  const journey = routingData?.journey
  const preservation = routingData?.preservationInterest
  const afabJourneys = ["ASSISTED_REPRODUCTION", "TRY_PREGNANT", "PREGNANT"]
  if (afabJourneys.includes(journey)) {
    return Workflows.AFAB_MEDICAL_QUESTIONS
  } else if (preservation === "PRESERVE_EGGS" && journey === "PRESERVATION") {
    return Workflows.AFAB_MEDICAL_QUESTIONS
  } else if (preservation === "PRESERVE_SPERM" && journey === "PRESERVATION") {
    return Workflows.AMAB_MEDICAL_QUESTIONS
  }
}
